// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__RT2iY","dragIcon":"Choice_dragIcon__1q_SF","left":"Choice_left__4rT_e","input":"Choice_input__1hdeZ"};